import { Component, inject, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "stat-hjelp",
  templateUrl: "./komigang.component.html",
  standalone: true,
})
export class KomigangComponent implements OnInit {
  titleService = inject(Title);

  ngOnInit() {
    this.titleService.setTitle("Statistikk - Kom i gang - Husbanken");
  }
}
